import { Card, CardBody, Col } from "reactstrap";
import { HorizontalDottedDividerTitle } from "../../../Constants/Constants";
import { HorizontalDottedDividerData, HorizontalDottedDividerSubTitle } from "../../../Data/UiKits/Divider";
import CommonCardHeader from "../../CommonComponents/CommonCardHeader/CommonCardHeader";

const HorizontalDottedDivider = () => {
  return (
    <Col xxl="4" md="6" className="box-col-6">
      <Card>
        <CommonCardHeader title={HorizontalDottedDividerTitle} span={HorizontalDottedDividerSubTitle} />
        <CardBody className="main-divider">
          {HorizontalDottedDividerData.map((item, index) => (
            <div className={`divider-body divider-body-3 divider-${item.color}`} key={index}>
               {item.text}
            </div>
          ))}
        </CardBody>
      </Card>
    </Col>
  );
};

export default HorizontalDottedDivider;
